import { Controller } from '@hotwired/stimulus';

// Prototype .gal-wrap / .gal-btn — horizontal scroll strip with prev/next.
export default class extends Controller {
  static targets = ['track'];

  prev() {
    this.scroll(-1);
  }

  next() {
    this.scroll(1);
  }

  scroll(direction) {
    const track = this.trackTarget;
    track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
  }
}
